import { Form } from 'react-final-form';
import { Box, Grid, MenuItem } from '@mui/material';

import { TextField, Select } from '@occc-app/design-system';
import { ConfirmDialog, LinearProgress, Typography } from '@occc/ui-design-system';
import { Retailer_Network_User_Role } from '@occc/graphql';

import { validateRetailerNetworkCreateAndAddNewUser } from '../retailer-network-users-configuration.validation';
import {
  NewUserFormProps,
  NewRetailerNetworkUserFormValues,
} from '../retailer-network-users-configuration.types';

const roleOptions = [
  {
    label: 'Network Admin',
    value: Retailer_Network_User_Role.RetailerNetworkAdmin,
  },
  {
    label: 'Network User',
    value: Retailer_Network_User_Role.RetailerNetworkUser,
  },
];

type RetailerNetworkAddNewUserDialogProps = {
  open: boolean;
  onClose: () => void;
  onSubmit: (values: NewRetailerNetworkUserFormValues) => Promise<void>;
};

export const RetailerNetworkAddNewUserDialog = ({
  open,
  onClose,
  onSubmit,
}: RetailerNetworkAddNewUserDialogProps) => {
  const dialogTitle = (
    <>
      <Typography component='span' variant='h6'>
        Create a New User
      </Typography>
      <Typography color='textSecondary'>
        Network admins can edit all the network details, add new sites and new users. Network users
        have read-only access.
      </Typography>
    </>
  );

  const renderForm: NewUserFormProps['render'] = ({ handleSubmit, submitting, valid }) => {
    return (
      <ConfirmDialog
        dialogTitle={dialogTitle}
        onClose={onClose}
        open={open}
        maxWidth='md'
        fullWidth
        confirmButtonText='CREATE USER AND ADD TO NETWORK'
        confirmButtonProps={{
          onClick: handleSubmit,
          disabled: submitting || !valid,
        }}
      >
        <Box pt={1}>
          {submitting && <LinearProgress sx={{ mb: 3 }} />}
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <TextField required name='firstName' label='First Name' />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField required name='lastName' label='Last Name' />
            </Grid>
            <Grid item xs={12} md={4}>
              <Select required name='userRole' label='Role' sx={{ width: '100%' }}>
                {roleOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField required type='email' name='email' label='Email' />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField name='phoneNumber' label='Phone Number' />
            </Grid>
          </Grid>
        </Box>
      </ConfirmDialog>
    );
  };

  return (
    <Form<NewRetailerNetworkUserFormValues>
      onSubmit={onSubmit}
      render={renderForm}
      validate={validateRetailerNetworkCreateAndAddNewUser}
    />
  );
};
